import modalBox from '@/components/form-modal/modal-tools';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import ls from '@/utils/local-storage';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import { create_c_z_record } from '@/api/mjstore-model';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
export const btn_record = {
  cb: () => {
    const editModal = reactive({
      visible: true,
      loading: false,
      title: '充值',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          col: [5, 4],
        },
        fields: [
          {
            type: 'remotemodal',
            name: 'customer_id',
            label: '会员姓名',
            disabled: false,
            placeholder: '请选择会员姓名',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-customer',
          },
          {
            type: 'input',
            name: 'price',
            label: '收款金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写收款金额',
          },
          {
            type: 'input',
            name: 'cz_flje',
            label: '返利金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写返利金额',
          },
          {
            type: 'remoteselect',
            name: 'sk_type_id',
            label: '收款方式',
            disabled: false,
            placeholder: '请选择收款方式',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-sktype',
          },
          {
            type: 'remoteselect',
            name: 'cxzc_id',
            label: '促销政策',
            disabled: false,
            placeholder: '请选择促销政策',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-policy',
          },
          {
            type: 'datepicker',
            name: 'date',
            label: '充值日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            showTime: true,
            placeholder: '请选择充值日期',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '执行门店',
            disabled: false,
            placeholder: '请选择执行门店',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-staff',
          },
          {
            type: 'input',
            name: 'mark',
            label: '备注',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写备注',
          },
        ],
        rules: {
          customer_id: [{ required: true, message: '请填输入会员姓名' }],
          date: [{ required: true, message: '请填输入充值日期' }],
          mark: [{ required: true, message: '请填输入备注' }],
          shop_id: [{ required: true, message: '请填输入执行门店' }],
        },
        model: reactive({
          org_id: current_org?.id,
          is_active: true,
          customer_id: null,
          price: null,
          cz_flje: null,
          sk_type_id: null,
          cxzc_id: null,
          staff_id: null,
          date: null,
          mark: null,
          shop_id: null,
        }),
      },
      options: {},
      ok: (payload: any) => {
        return new Promise(resolve => {
          editModal.loading = true;
          create_c_z_record(payload)
            .then(() => {
              message.success('充值成功');
              resolve(null);
            })
            .finally(() => {
              editModal.loading = false;
            });
        });
      },
    });
    modalBox(editModal);
  },
};
